import React, { Component } from 'react';
import { number } from 'prop-types';
import AccordionItem from "./AccordionItem.js";

class Accordion extends Component {
  static PropTypes = {
    defaultExpandedId: number
  }

  constructor(props) {
    super(props);
    this.state = {
      defaultExpandedId: null
    };
  }


  render() {
    this.children = React.Children.map(this.props.children, (child) => {
      return (
        <AccordionItem component={child} />
      );
    });

    return (
      <div className='accordion-container'>
        {this.children}
      </div>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/common/accordion/Accordion.js